import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  SwitchButton,
  AlertMessage,
  AlertNotice,
  Spinner,
  EventDashboardDetails,
} from 'shared/components';
import { ChecklistCard } from 'features/event-checklist/index';

import './EventChecklistDashboard.scss';

class EventChecklistDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPre: props.showPre,
      showSuccessMessage: props.showSuccessMessage,
    };

    this.switchTabs = this.switchTabs.bind(this);
    this.removeSuccessMessage = this.removeSuccessMessage.bind(this);
  }

  switchTabs() {
    this.setState((prevState) => ({
      showPre: !prevState.showPre,
    }));
  }

  removeSuccessMessage() {
    this.setState({
      showSuccessMessage: false,
    });
  }

  render() {
    const { tcEvent, tcCycle, eventTasks, completedEventTasks, toDoEventTasks, loadingEventTasks } =
      this.props;
    const { showPre, showSuccessMessage } = this.state;
    const tasksType = showPre ? 'pre' : 'post';

    if (loadingEventTasks) {
      return <Spinner />;
    }

    return (
      <div className="event-checklist-dashboard">
        <div className="header-section position-relative">
          <h4>{this.props.t('eventChecklist.title')}</h4>
          <EventDashboardDetails
            date={tcEvent.testingEvent.name}
            name={tcCycle.testCenterProgram.testCenter.name}
          />
        </div>
        <SwitchButton
          leftLabel={this.props.t('eventChecklist.preTestLabel')}
          rightLabel={this.props.t('eventChecklist.postTestLabel')}
          leftActive={showPre}
          switchButton={this.switchTabs}
          description={this.props.t('eventChecklist.guidance')}
        />
        <div>
          <p className="fw-bold mt-4">
            {this.props.t('eventChecklist.toDoTitle', {
              toDo: toDoEventTasks[tasksType].length,
            })}
          </p>
          {toDoEventTasks[tasksType].length ? (
            toDoEventTasks[tasksType].map((task) => (
              <ChecklistCard key={task.taskId} task={task} eventId={tcEvent.id} />
            ))
          ) : (
            <AlertNotice message={this.props.t('eventChecklist.noSectionInProgress')} />
          )}
          <p className="fw-bold mt-5">
            {this.props.t('eventChecklist.completedTitle', {
              completed: completedEventTasks[tasksType].length,
              total: eventTasks[tasksType].length,
            })}
          </p>
          {completedEventTasks[tasksType].length ? (
            completedEventTasks[tasksType].map((task) => (
              <ChecklistCard key={task.taskId} task={task} eventId={tcEvent.id} />
            ))
          ) : (
            <AlertNotice message={this.props.t('eventChecklist.noSectionCompleted')} />
          )}
        </div>
        <button className="btn btn-outline ml-0 mt-3" onClick={() => this.props.goBack()}>
          {this.props.t('common.labels.back')}
        </button>
        <AlertMessage
          show={showSuccessMessage}
          removeMessage={this.removeSuccessMessage}
          message={this.props.t('eventChecklist.changesSavedSuccessfully')}
        />
      </div>
    );
  }
}

EventChecklistDashboard.propTypes = {
  tcCycle: PropTypes.shape({}).isRequired,
  tcEvent: PropTypes.shape({}).isRequired,
  eventTasks: PropTypes.shape({}).isRequired,
  completedEventTasks: PropTypes.shape({}).isRequired,
  toDoEventTasks: PropTypes.shape({}).isRequired,
  showPre: PropTypes.bool.isRequired,
  showSuccessMessage: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(EventChecklistDashboard);
